try {
  // "env" is defined in webpack build config
  Object.entries(BUILD_ENV).forEach(([key, value]) => {
    window[key] = value
  })
} catch (e) {
  console.error('ERROR: unable to set browser globals')
}
